<template>
  <div class="min-h-screen flex flex-col">
    <NavBar></NavBar>
    <ViewEvent
      :simpleScheduledEvent="selectedSimpleScheduledEvent"
      :schedule="simpleEventSchedule"
      :calendarID="calendarID"
      :userID="$route.params.coachId"
      :memberships="memberships"
      @updatedSimpleScheduledEvent="simpleScheduledEventChanges"
      @deletedSimpleScheduledEvent="simpleScheduledEventChanges"
    ></ViewEvent>
    <button
      data-bs-toggle="modal"
      data-bs-target="#ViewEvent"
      style="display: none"
      id="openViewEvent"
    ></button>
    <div
      :class="{
        container: !isMobile,
        'mt-5': true,
        'justify-content-center': true,
      }"
    >
      <div :class="{ card: !isMobile, 'card-form__inner': !isMobile }">
        <h1 class="card-title text-center">Schedule</h1>
        <br />
        <br />
        <div
          :class="{
            'card-body': !isMobile,
            'justify-content-center': true,
            center: true,
            'text-center': true,
          }"
        >
          <FullCalendar
            :options="calendarOptions"
            locale="en"
            @eventClick="logEvent"
          ></FullCalendar>
        </div>
        <br />
      </div>
    </div>
    <NavFooter></NavFooter>
  </div>
</template>
<script>
import NavBar from '../components/NavBar.vue'
import NavFooter from '../components/NavFooter.vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import FullCalendar from '@fullcalendar/vue3'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import moment from 'moment'
import ViewEvent from '../components/Calendar/ViewEvent.vue'
import {
  validateColor,
  DEFAULT_PRIMARY_COLOR,
  DEFAULT_SECONDARY_COLOR,
} from '../utils/colorValidation'

// import swal from "sweetalert";

export default {
  components: {
    NavBar,
    NavFooter,
    FullCalendar,
    ViewEvent,
  },
  data() {
    return {
      user: {},
      currentCampEvent: {
        title: '',
        start: '',
        end: '',
        camperName: '',
        campName: '',
        campID: '',
        isCamp: false,
        camperLength: 0,
      },
      calendarID: '',
      calendars: [],
      selectedCalendarIndex: 0,
      fcEvents: [],
      selectedSimpleScheduledEventID: '',
      selectedSimpleScheduledEvent: {},
      simpleEventSchedule: {},
      newEventDate: '',
      memberships: [],
    }
  },
  methods: {
    goToBookedSessions() {
      this.$router.push('/Dashboard/Calendar/BookedSessions')
    },

    simpleScheduledEventChanges() {
      window.location.reload()
    },

    getCalendar() {
      Swal.fire({
        title: 'Loading Events...',
        didOpen: () => {
          Swal.showLoading()
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
      })
      let url =
        import.meta.env.VITE_APP_DB_URL +
        'shop/getCalendar?userID=' +
        this.$route.params.coachId
      axios
        .get(url)
        .then(response => {
          this.fcEvents = response.data.fcEvents
          Swal.close()
        })
        .catch(error => {
          console.log(error)
          Swal.close()
        })
    },
    async logEvent(event) {
      try {
        let eventDetails
        try {
          eventDetails = JSON.parse(event.event.id)
        } catch (e) {
          console.error('Error parsing event ID:', e)
          // If parsing fails, try to clean the string first
          const cleanedId = event.event.id.replace(/[\n\r\t]/g, '').trim()
          eventDetails = JSON.parse(cleanedId)
        }

        this.selectedSimpleScheduledEvent = {}
        this.simpleEventSchedule = {}

        if (eventDetails.isCamp) {
          // Handle camp events
          const startDate = new Date(eventDetails.campDate)
          const endDate = new Date(eventDetails.campDate)

          this.simpleEventSchedule = {
            date: moment(eventDetails.campDate).format('YYYY-MM-DD'),
            startTime: startDate.toLocaleTimeString('en-US', {
              hour12: false,
              hour: '2-digit',
              minute: '2-digit',
            }),
            endTime: endDate.toLocaleTimeString('en-US', {
              hour12: false,
              hour: '2-digit',
              minute: '2-digit',
            }),
          }

          this.selectedSimpleScheduledEvent = {
            name: eventDetails.campName || event.event.title,
            location: eventDetails.campLocation || '',
            description: eventDetails.campDescription || '',
            campID: eventDetails.campID,
            isCamp: true,
            camperLength: eventDetails.camperLength || 0,
            campPrice: eventDetails.campPrice || '',
            campMaxParticipants: eventDetails.campMaxParticipants || '',
          }
          document.getElementById('openViewEvent').click()
        } else {
          // Handle scheduled events
          this.selectedSimpleScheduledEventID = eventDetails.eventID
          await this.getSelectedSimpleScheduledEvent(eventDetails)
          document.getElementById('openViewEvent').click()
        }
      } catch (error) {
        console.error('Error handling event click:', error)
        Swal.fire({
          title: 'Error',
          text: 'There was an error loading the event details. Please try again.',
          icon: 'error',
        })
      }
    },

    async getSelectedSimpleScheduledEvent(calendarEvent) {
      let url =
        import.meta.env.VITE_APP_DB_URL +
        'scheduling/getSimpleScheduledEvent?eventID=' +
        this.selectedSimpleScheduledEventID
      axios.get(url).then(response => {
        this.selectedSimpleScheduledEvent = response.data.simpleScheduledEvent
        this.simpleEventSchedule = response.data.simpleScheduledEvent.schedule

        this.simpleEventSchedule.date = moment(calendarEvent.start).format(
          'YYYY-MM-DD'
        )

        // Check for alterations
        for (const alteration of response.data.simpleScheduledEvent.schedule
          .alterations) {
          if (
            moment(alteration.date).format('YYYY-MM-DD') ===
            moment(calendarEvent.start).format('YYYY-MM-DD')
          ) {
            this.simpleEventSchedule.date = moment(alteration.date).format(
              'YYYY-MM-DD'
            )
            this.simpleEventSchedule.startTime = alteration.startTime
            this.simpleEventSchedule.endTime = alteration.endTime
            this.selectedSimpleScheduledEvent.name = alteration.name
            this.selectedSimpleScheduledEvent.location = alteration.location
            this.selectedSimpleScheduledEvent.description =
              alteration.description
          }
        }
      })
    },
    async fetchMemberships() {
      try {
        const response = await axios.get(
          import.meta.env.VITE_APP_DB_URL +
            'membership/getCoachMembershipsExternal?id=' +
            this.$route.params.coachId,
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('jwt'),
            },
          }
        )
        this.memberships = response.data
      } catch (error) {
        console.error('Error fetching memberships:', error)
      }
    },
  },

  created() {
    this.getCalendar()
    this.fetchMemberships()
  },
  computed: {
    getCalendarID() {
      return this.calendarID || this.calendars[this.selectedCalendarIndex]?._id
    },
    validatedPrimaryColor() {
      return validateColor(
        this.$route.params.primaryColor,
        DEFAULT_PRIMARY_COLOR
      )
    },
    validatedSecondaryColor() {
      return validateColor(
        this.$route.params.secondaryColor,
        DEFAULT_SECONDARY_COLOR
      )
    },
    getEventColor() {
      return '#' + this.validatedPrimaryColor
    },
    getEventHoverColor() {
      return '#' + this.validatedSecondaryColor
    },
    calendarOptions() {
      return {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        weekends: true,
        selectable: true,
        eventClick: this.logEvent,
        events: this.fcEvents,
        eventColor: '#' + this.validatedPrimaryColor,
        eventMouseEnter: info => {
          info.el.style.cursor = 'pointer'
          info.el.style.backgroundColor = '#' + this.validatedSecondaryColor
        },
        eventMouseLeave: info => {
          info.el.style.backgroundColor = '#' + this.validatedPrimaryColor
        },
        dayCellDidMount: info => {
          info.el.style.cursor = 'pointer'
          info.el.addEventListener('mouseenter', () => {
            info.el.style.backgroundColor = '#E6E6FA'
          })
          info.el.addEventListener('mouseleave', () => {
            info.el.style.backgroundColor = ''
          })
        },
      }
    },

    isMobile() {
      var check = false
      ;(function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
            a.substr(0, 4)
          )
        )
          check = true
      })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    },
  },
  mounted() {},
}
</script>
<style scoped>
.sticky {
  position: fixed;
  top: 0;
  width: 100%;
}

.currencyinput {
  border: 1px inset #ccc;
}
.currencyinput input {
  border: 0;
}

.sticky + .content {
  padding-top: 102px;
}

.grow {
  transition: all 0.2s ease-in-out;
}

.grow:hover {
  transform: scale(1.1);
}

.order {
  animation: bounce 0.7s infinite alternate;
}

.newGradient {
  background-color: #ff3cac;
  background-image: linear-gradient(
    225deg,
    #32bd28 0%,
    #45487a 50%,
    #45487a 100%
  );
}

@keyframes bounce {
  to {
    transform: scale(1.1);
  }
}
</style>
